<div class="lazy-img-placeholder">
    <!--suppress RequiredAttributes -->
    <img *ngIf="images && images.length > 0" class="lazy-img" [alt]="alt" [attr.src]="src" [attr.srcset]="srcset" [sizes]="sizes">
</div>
